var _path, _circle, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6115 0.0184326C5.26463 0.0184326 0.11145 5.17161 0.11145 11.5184C0.11145 17.8653 5.26463 23.0184 11.6115 23.0184C17.9583 23.0184 23.1115 17.8653 23.1115 11.5184C23.1115 5.17161 17.9583 0.0184326 11.6115 0.0184326ZM11.6115 1.78766C16.9817 1.78766 21.3422 6.14823 21.3422 11.5184C21.3422 16.8886 16.9817 21.2492 11.6115 21.2492C6.24125 21.2492 1.88068 16.8886 1.88068 11.5184C1.88068 6.14823 6.24125 1.78766 11.6115 1.78766Z",
    fill: "#0076DC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.09107,
    cy: 7.99805,
    r: 1.17347,
    fill: "#0076DC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.1318,
    cy: 7.99805,
    r: 1.17347,
    fill: "#0076DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9764 17.0148C15.9764 17.0148 14.5091 14.1001 11.6114 14.1001C8.71372 14.1001 7.24644 17.0148 7.24644 17.0148C7.02646 17.4614 7.20482 18.0057 7.64596 18.229C8.0859 18.4523 8.62216 18.2712 8.84214 17.8235C8.84214 17.8235 9.75295 15.9105 11.6114 15.9105C13.4699 15.9105 14.3807 17.8235 14.3807 17.8235C14.6007 18.2712 15.137 18.4523 15.5769 18.229C16.018 18.0057 16.1964 17.4614 15.9764 17.0148Z",
    fill: "#0076DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSads);
export default __webpack_public_path__ + "static/media/sads.da6d791f9337a47f680b74e290a81606.svg";
export { ForwardRef as ReactComponent };